import { makeStyles } from '@material-ui/core/styles'

const TermsAndConditionsPrivacyPolicy = () => {
  const classes = useStyles()

  return (
    <>
      <div className={classes.mainContainer}>
        <div>
          <span className={classes.mainHeading}>
            Terms & Conditions | Privacy Policy
          </span>
          <br></br>
          <span className={classes.description}>
            Trovity.com including online platform(s), its web applications owned
            by the Company (‘Website’) recognizes the importance of maintaining
            your privacy. Trovity.com is committed to maintain the
            confidentiality, integrity and security of all information of our
            users. This Privacy Policy describes how Trovity.com collects and
            handles certain information it may collect and/or receive from you
            via the use of this Website. Please see below for details on what
            type of information we may collect from you, how that information is
            used in connection with the services offered through our Website and
            relevant information shared with our authorized business partners
            only for the purpose of policy solicitation process, pre/post-sale
            servicing, claim servicing and providing you any other services as
            permissible under applicable laws. This Privacy Policy applies to
            current and former visitors to our Website and our customers. By
            visiting and/or using our Website, you agree to this Privacy Policy.
          </span>
          <br></br>
          <span className={classes.heading}>
            This Privacy Policy is published in compliance of:
          </span>
          <br></br>
          <span className={classes.description}>
            the Information Technology Act, 2000; and the Information Technology
            (Reasonable Security Practices and Procedures and Sensitive Personal
            Information) Rules, 2011 (the “SPDI Rules”) as amended from time to
            time. By using the Trovity.com and/or registering yourself at
            www.Trovity.com, you authorize Trovity Insuretech Insurance Broking
            Services Private Limited (including its authorized representatives
            and its business partners) (Trovity/Company) to contact you via
            email or phone call or sms and offer you our services for the
            product you have opted for, imparting product knowledge, offer
            promotional offers running on the Website and offers by its
            authorized business partners and associated third parties (to the
            extent permissible), for which reasons your information may be
            collected in the manner as detailed under this Policy. You hereby
            agree that you authorize Trovity.com to contact you for the above
            mentioned purposes even if you have registered yourself under DND or
            DNC or NCPR service(s). Your authorization, in this regard, shall be
            valid as long as your account is not deactivated by either you or
            us.
          </span>
          <br></br>
          <span className={classes.description}>
            Controllers of Personal Information{' '}
          </span>
          <br></br>
          <span className={classes.description}>
            Your personal data will be stored and collected by Trovity
            Insuretech Insurance Broking Services Private Limited.
          </span>
          <br></br>
          <span className={classes.heading}>
            Purposes of collection of your data{' '}
          </span>
          <br></br>
          <span className={classes.description}>
            Trovity.com collects your information when you register for an
            account, when you use its products or services, visit its Website’s
            pages or when an employer organization shares its employee
            information. When you register with Trovity.com, you are asked for
            submitting certain information which may be personal to you such as
            first name, last name, state and city of residence, email address,
            mobile number, date of birth, financial, know your customer and
            medical records etc. Once you register at the Website and sign in
            you are not anonymous to us. Also, you are asked for your contact
            number during registration and may be sent SMSs, notifications about
            our services to your wireless device. Hence, by registering you
            authorize the Trovity.com to send texts and email alerts to you with
            your login details and any other service requirements, including
            promotional mails and SMSs.
          </span>
          <br></br>
          <span className={classes.heading}>
            We use your information in order to:
          </span>
          <br></br>
          <span className={classes.description}>
            Respond to queries or requests submitted by you.
          </span>
          <br></br>
          <span className={classes.description}>
            Process orders or applications submitted by you.
          </span>
          <br></br>
          <span className={classes.description}>
            Administer or otherwise carry out our obligations in relation to any
            agreement with our authorized business partners in connection with
            our business operations and functions for the purpose of insurance
            solicitation, providing pre/post sale services, claims servicing and
            providing you any other services as permissible under applicable
            laws or any other insurance related purposes.
          </span>
          <br></br>
          <span className={classes.description}>
            Anticipate and resolve problems with any services supplied to you.
          </span>
          <br></br>
          <span className={classes.description}>
            Offer group insurance cover and wellness corner offerings / health
            and wellness related information to your employer organization.
          </span>
          <br></br>
          <span className={classes.description}>
            To send you information about promotions or offers from Insurance
            Companies to the extent permissible under applicable laws. We might
            also tell you about new features or products.
          </span>
          <br></br>
          <span className={classes.description}>
            To make our website and the services offered better. We may combine
            information we get from you with information about you we get from
            our business partners or third parties as permissible under
            applicable laws.
          </span>
          <br></br>
          <span className={classes.description}>
            To send you notices, communications, offer alerts relevant to your
            use of the Services offered on this Website.
          </span>
          <br></br>
          <span className={classes.description}>
            Third parties and outsourced entities for the reasons consistent
            with the purposes for which the information was collected and/or
            other purposes as per applicable law.
          </span>
          <br></br>
          <span className={classes.description}>
            Where we need to comply with a legal obligation as per applicable
            legal and regulatory framework.
          </span>
          <br></br>
          <span className={classes.description}>
            As otherwise provided in this Privacy Policy.
          </span>
          <span className={classes.description}>
            Some features of this Website or our Services will require you to
            furnish your personally identifiable information as provided by you
            under your account section on our Website.
          </span>
          <br></br>
          <span className={classes.heading}>
            Information Sharing and Disclosure
          </span>
          <br></br>
          <span className={classes.description}>
            We may share your Information submitted on the Website to any third
            party/service provider/business partner without obtaining your prior
            consent in the following limited circumstances:
          </span>
          <br></br>
          <span className={classes.description}>
            1. When it is requested or required by law or by any court or
            governmental agency or authority to disclose, for the purpose of
            verification of identity, or for the prevention, detection,
            investigation including cyber incidents, or for prosecution and
            punishment of offences. These disclosures are made in good faith and
            belief that such disclosure is reasonably necessary for enforcing
            these Terms and Conditions; for complying with the applicable laws
            and regulations.
          </span>
          <br></br>
          <span className={classes.description}>
            2. Trovity shall transfer information about you in case Trovity is
            acquired by or merged with another company.
          </span>
          <br></br>
          <span className={classes.description}>
            3. Where we need to comply with a legal obligation as per applicable
            legal and regulatory framework.
          </span>
          <br></br>
          <span className={classes.heading}>We Collect Cookies</span>
          <br></br>
          <span className={classes.description}>
            A cookie is a piece of data stored on the user’s computer tied to
            information about the user. We may use both session ID cookies and
            persistent cookies. For session ID cookies, once you close your
            browser or log out, the cookie terminates and is erased. A
            persistent cookie is a small text file stored on your computer’s
            hard drive for an extended period of time. Session ID cookies may be
            used by PRP to track user preferences while the user is visiting the
            website. They also help to minimize load times and save on server
            processing. Persistent cookies may be used by PRP to store whether,
            for example, you want your password remembered or not, and other
            information. Cookies used on the PRP website do not contain
            personally identifiable information.
          </span>
          <br></br>
          <span className={classes.heading}>Log Files</span>
          <br></br>
          <span className={classes.description}>
            Like most standard websites, we use log files. This information may
            include internet protocol (IP) addresses, browser type, internet
            service provider (ISP), referring/exit pages, platform type,
            date/time stamp, and number of clicks to analyze trends, administer
            the site, track user’s movement in the aggregate, and gather broad
            demographic information for aggregate use. We may combine this
            automatically collected log information with other information we
            collect about you. We do this to improve services we offer to you,
            to improve marketing, analytics or site functionality.
          </span>
          <br></br>
          <span className={classes.heading}>Email- Opt out </span>
          <br></br>
          <span className={classes.description}>
            If you are no longer interested in receiving e-mail announcements
            and other marketing information from us, please e-mail your request
            at: care@Trovity.com. Please note that it may take about 10 days to
            process your request.
          </span>
          <br></br>
          <span className={classes.heading}>Security</span>
          <br></br>
          <span className={classes.description}>
            We employ appropriate technical and organizational security measures
            at all times to protect the information we collect from you. We use
            multiple electronic, procedural, and physical security measures to
            protect against unauthorized or unlawful use or alteration of
            information, and against any accidental loss, destruction, or damage
            to information. However, no method of transmission over the
            Internet, or method of electronic storage, is 100% secure.
            Therefore, we cannot guarantee its absolute security. Further, you
            are responsible for maintaining the confidentiality and security of
            your login id and password, and may not provide these credentials to
            any third party.
          </span>
          <br></br>
          <span className={classes.heading}>ISO 27001</span>
          <br></br>
          <span className={classes.description}>
            ISO 27001 ISO/IEC 27001 is the international standard for management
            of information security and provides a systematic approach to keep
            sensitive company information secure. Getting the ISO 27001
            certificate is a reassurance for our customers that Trovity.com
            complies with the highest standards regarding information security.
            Trovity is ISO/IEC 27001 certified company. We have implemented the
            ISO/IEC 27001 standard for all processes supporting the development
            and delivery of services by Trovity.com. Trovity.com understands
            that the confidentiality, integrity, and availability of your
            information are vital to our business operations and our own
            success.
          </span>
          <br></br>
          <span className={classes.description}>Links to Other Websites</span>
          <br></br>
          <span className={classes.description}>
            There might be other sites linked to Trovity.com. Personal
            information that you provide to those sites are not our property.
            These affiliated sites may have different privacy practices and we
            encourage you to read their privacy policies of these website when
            you visit them.
          </span>
          <br></br>
          <span className={classes.description}>Changes in this Privacy</span>
          <br></br>
          <span className={classes.description}>
            Policy Trovity.com reserves the right to change this policy from
            time to time, at its sole discretion. We may update this privacy
            policy to reflect changes to our information practices. We encourage
            you to periodically review
          </span>
          <br></br>
          <span>Data Grievance Officer</span>
          <br></br>
          <span className={classes.description}>
            In case you have any grievances with respect to in accordance with
            applicable law on Information Technology and rules made there under,
            the name and contact details of the
          </span>
          <br></br>
          <br></br>
          <span className={classes.subDescription}>
            Grievance Officer are provided below:
          </span>
          <br></br>
          <br></br>
          <span className={classes.description}> Mr. D V V Srinivasa Rao</span>
          <br></br>
          <br></br>
          <a
            href={process.env.REACT_APP_HOME_URL}
            target='_blank'
            rel='noopener noreferrer'
            className={classes.link}
          >
            Trovity.com
          </a>
          <br></br>
          <br></br>
          <span className={classes.description}>
            3rd Floor, Kalajyothi Building, Masjid Band Circle, Kondapur,
            Hyderabad, Telangana – 500084
          </span>
          <br></br>
          <br></br>
          <span className={classes.description}> Tel – 99593 74321</span>
          <br></br>
          <br></br>
          <span className={classes.description}>Email :</span>
          <span className={classes.link}> info@trovity.com</span>,<br></br>
          <br></br>
          <span className={classes.description}>
            If you have questions, concerns, or suggestions regarding our
            Privacy Policy, we can be reached using the contact information on
            our Contact Us page or at care@Trovity.com.
          </span>
          <br></br>
          <span className={classes.description}>
            In case your grievance is in relation to Information Technology
            (Intermediary Guidelines and Digital Media Ethics Code) Rules, 2021,
            we shall acknowledge your complaint within twenty-four hours and
            dispose off such the complaint within a period of fifteen days from
            the date of its receipt. Disposal of complaint shall include all
            actions as considered necessary by Trovity.
          </span>
          <br></br>
        </div>
      </div>
    </>
  )
}
export default TermsAndConditionsPrivacyPolicy
const useStyles = makeStyles({
  mainContainer: {
    backgroundImage:
      'url(https://uat.trovity.com/wp-content/uploads/2023/05/Mask-group-7.png)',
    backgroundPosition: 'center center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    padding: '25px',
    backgroundColor: '#FFF',
  },
  mainHeading: {
    fontSize: '24px',
    lineHeight: '2.875',
    fontWeight: '600',
  },
  description: {
    fontSize: '16px',
    lineHeight: '1.875',
  },
  heading: {
    fontSize: '18px',
    fontWeight: '600',
    lineHeight: '2.875',
  },
  link: {
    fontSize: '16px',
    color: '#EF669B',
    lineHeight: '1.875',
    cursor: 'pointer',
  },
  subDescription: {
    fontSize: '16px',
    fontWeight: '600',
    lineHeight: '1.875',
  },
})
